/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { RoleFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListAccountsQueryVariables = Types.Exact<{
  input: Types.ListAccountsInput;
}>;


export type ListAccountsQuery = { __typename?: 'Query', listAccounts: Array<{ __typename?: 'AccountModel', account_id: string, created_at?: string | null, account_name?: string | null, account_type?: Types.AccountType | null, user_count: number, ownerUser?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string, last_login?: string | null } | null }> };

export type ListAccountChildrenQueryVariables = Types.Exact<{
  input: Types.GetAccountInput;
}>;


export type ListAccountChildrenQuery = { __typename?: 'Query', getAccountRecord: { __typename?: 'AccountModel', account_id: string, children: Array<{ __typename?: 'AccountModel', account_id: string, parent_id?: string | null, created_at?: string | null, account_name?: string | null, account_type?: Types.AccountType | null, user_count: number, ownerUser?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string, last_login?: string | null } | null }> } };

export type GetAccountRecordQueryVariables = Types.Exact<{
  input: Types.GetAccountInput;
}>;


export type GetAccountRecordQuery = { __typename?: 'Query', getAccountRecord: { __typename?: 'AccountModel', account_id: string, city?: string | null, owner_id?: string | null, currency?: string | null, parent_id?: string | null, region_id?: string | null, status_id?: string | null, country_id?: string | null, zip_postal?: string | null, created_at?: string | null, updated_at?: string | null, is_deleted?: boolean | null, account_name?: string | null, phone_number?: string | null, payment_type?: string | null, billing_address?: string | null, billing_address2?: string | null, created_user_id?: string | null, stripe_customer_id?: string | null, account_type?: Types.AccountType | null, profile_picture?: string | null } };

export type GetAccountUsersQueryVariables = Types.Exact<{
  input: Types.GetAccountInput;
}>;


export type GetAccountUsersQuery = { __typename?: 'Query', getAccountRecord: { __typename?: 'AccountModel', account_id: string, users: Array<{ __typename?: 'UserModel', user_id: string, account_id: string, email?: string | null, first_name: string, middle_name?: string | null, last_name: string, last_login?: string | null, created_at: string, updated_at: string, profile_picture?: string | null, status: Types.UserStatus, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string } | null, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, account: { __typename?: 'AccountModel', account_id: string, account_name?: string | null } }> } };

export type GetOrganizationProfileQueryVariables = Types.Exact<{
  input: Types.GetAccountInput;
}>;


export type GetOrganizationProfileQuery = { __typename?: 'Query', getAccountRecord: { __typename?: 'AccountModel', account_id: string, account_name?: string | null, phone_number?: string | null, email?: string | null, profile_picture?: string | null, billing_address?: string | null, billing_address2?: string | null, city?: string | null, region_id?: string | null, status_id?: string | null, country_id?: string | null, zip_postal?: string | null, account_address?: string | null, account_address2?: string | null, account_city?: string | null, account_country_id?: string | null, account_region_id?: string | null, account_zip_postal?: string | null } };

export type GetAccountKpiQueryVariables = Types.Exact<{
  input: Types.GetAccountInput;
}>;


export type GetAccountKpiQuery = { __typename?: 'Query', getAccountRecord: { __typename?: 'AccountModel', account_id: string, kpi: { __typename?: 'AccountKpiModel', active_patients: number, patients_with_alerts: number, alerts_within_24_hours: number, open_alerts: number, patients_with_devices: number } } };

export type UpdateAccountBillingAddressMutationVariables = Types.Exact<{
  input: Types.UpdateAccountBillingAddressModelInput;
}>;


export type UpdateAccountBillingAddressMutation = { __typename?: 'Mutation', updateAccountBillingAddress: { __typename?: 'UpdateAccountResponse', success: boolean, message: string, data?: { __typename?: 'AccountModel', account_id: string, updated_at?: string | null, billing_address?: string | null, billing_address2?: string | null, city?: string | null, region_id?: string | null, country_id?: string | null, zip_postal?: string | null } | null } };

export type UpdateAccountRecordMutationVariables = Types.Exact<{
  input: Types.UpdateAccountModelInput;
}>;


export type UpdateAccountRecordMutation = { __typename?: 'Mutation', updateAccountRecord: { __typename?: 'UpdateAccountResponse', success: boolean, message: string, data?: { __typename?: 'AccountModel', account_id: string, account_name?: string | null, phone_number?: string | null, email?: string | null, profile_picture?: string | null, billing_address?: string | null, billing_address2?: string | null, city?: string | null, region_id?: string | null, status_id?: string | null, country_id?: string | null, zip_postal?: string | null, account_address?: string | null, account_address2?: string | null, account_city?: string | null, account_country_id?: string | null, account_region_id?: string | null, account_zip_postal?: string | null } | null } };

export type DeleteAccountMutationVariables = Types.Exact<{
  input: Types.DeleteAccountInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'UpdateAccountResponse', success: boolean } };


export const ListAccountsDocument = gql`
    query listAccounts($input: ListAccountsInput!) {
  listAccounts(input: $input) {
    account_id
    created_at
    account_name
    account_type
    ownerUser {
      user_id
      first_name
      last_name
      last_login
    }
    user_count
  }
}
    `;
export function useListAccountsQuery(baseOptions: Apollo.QueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables> & ({ variables: ListAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
      }
export function useListAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
        }
// @ts-ignore
export function useListAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccountsQuery, ListAccountsQueryVariables>;
export function useListAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccountsQuery | undefined, ListAccountsQueryVariables>;
export function useListAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
        }
export type ListAccountsQueryHookResult = ReturnType<typeof useListAccountsQuery>;
export type ListAccountsLazyQueryHookResult = ReturnType<typeof useListAccountsLazyQuery>;
export type ListAccountsSuspenseQueryHookResult = ReturnType<typeof useListAccountsSuspenseQuery>;
export type ListAccountsQueryResult = Apollo.QueryResult<ListAccountsQuery, ListAccountsQueryVariables>;
export const ListAccountChildrenDocument = gql`
    query listAccountChildren($input: GetAccountInput!) {
  getAccountRecord(input: $input) {
    account_id
    children {
      account_id
      parent_id
      created_at
      account_name
      account_type
      ownerUser {
        user_id
        first_name
        last_name
        last_login
      }
      user_count
    }
  }
}
    `;
export function useListAccountChildrenQuery(baseOptions: Apollo.QueryHookOptions<ListAccountChildrenQuery, ListAccountChildrenQueryVariables> & ({ variables: ListAccountChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>(ListAccountChildrenDocument, options);
      }
export function useListAccountChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>(ListAccountChildrenDocument, options);
        }
// @ts-ignore
export function useListAccountChildrenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>;
export function useListAccountChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>): Apollo.UseSuspenseQueryResult<ListAccountChildrenQuery | undefined, ListAccountChildrenQueryVariables>;
export function useListAccountChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>(ListAccountChildrenDocument, options);
        }
export type ListAccountChildrenQueryHookResult = ReturnType<typeof useListAccountChildrenQuery>;
export type ListAccountChildrenLazyQueryHookResult = ReturnType<typeof useListAccountChildrenLazyQuery>;
export type ListAccountChildrenSuspenseQueryHookResult = ReturnType<typeof useListAccountChildrenSuspenseQuery>;
export type ListAccountChildrenQueryResult = Apollo.QueryResult<ListAccountChildrenQuery, ListAccountChildrenQueryVariables>;
export const GetAccountRecordDocument = gql`
    query getAccountRecord($input: GetAccountInput!) {
  getAccountRecord(input: $input) {
    account_id
    city
    owner_id
    currency
    parent_id
    region_id
    status_id
    country_id
    zip_postal
    created_at
    updated_at
    is_deleted
    account_name
    phone_number
    payment_type
    billing_address
    billing_address2
    created_user_id
    stripe_customer_id
    account_type
    profile_picture
  }
}
    `;
export function useGetAccountRecordQuery(baseOptions: Apollo.QueryHookOptions<GetAccountRecordQuery, GetAccountRecordQueryVariables> & ({ variables: GetAccountRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountRecordQuery, GetAccountRecordQueryVariables>(GetAccountRecordDocument, options);
      }
export function useGetAccountRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountRecordQuery, GetAccountRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountRecordQuery, GetAccountRecordQueryVariables>(GetAccountRecordDocument, options);
        }
// @ts-ignore
export function useGetAccountRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountRecordQuery, GetAccountRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountRecordQuery, GetAccountRecordQueryVariables>;
export function useGetAccountRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountRecordQuery, GetAccountRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountRecordQuery | undefined, GetAccountRecordQueryVariables>;
export function useGetAccountRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountRecordQuery, GetAccountRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountRecordQuery, GetAccountRecordQueryVariables>(GetAccountRecordDocument, options);
        }
export type GetAccountRecordQueryHookResult = ReturnType<typeof useGetAccountRecordQuery>;
export type GetAccountRecordLazyQueryHookResult = ReturnType<typeof useGetAccountRecordLazyQuery>;
export type GetAccountRecordSuspenseQueryHookResult = ReturnType<typeof useGetAccountRecordSuspenseQuery>;
export type GetAccountRecordQueryResult = Apollo.QueryResult<GetAccountRecordQuery, GetAccountRecordQueryVariables>;
export const GetAccountUsersDocument = gql`
    query getAccountUsers($input: GetAccountInput!) {
  getAccountRecord(input: $input) {
    account_id
    users {
      user_id
      account_id
      email
      first_name
      middle_name
      last_name
      last_login
      created_at
      updated_at
      profile_picture
      status
      vitall_patient {
        vitall_patient_id
        patient_id
      }
      roles {
        ...RoleFields
      }
      account {
        account_id
        account_name
      }
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export function useGetAccountUsersQuery(baseOptions: Apollo.QueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables> & ({ variables: GetAccountUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountUsersQuery, GetAccountUsersQueryVariables>(GetAccountUsersDocument, options);
      }
export function useGetAccountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountUsersQuery, GetAccountUsersQueryVariables>(GetAccountUsersDocument, options);
        }
// @ts-ignore
export function useGetAccountUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountUsersQuery, GetAccountUsersQueryVariables>;
export function useGetAccountUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountUsersQuery | undefined, GetAccountUsersQueryVariables>;
export function useGetAccountUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountUsersQuery, GetAccountUsersQueryVariables>(GetAccountUsersDocument, options);
        }
export type GetAccountUsersQueryHookResult = ReturnType<typeof useGetAccountUsersQuery>;
export type GetAccountUsersLazyQueryHookResult = ReturnType<typeof useGetAccountUsersLazyQuery>;
export type GetAccountUsersSuspenseQueryHookResult = ReturnType<typeof useGetAccountUsersSuspenseQuery>;
export type GetAccountUsersQueryResult = Apollo.QueryResult<GetAccountUsersQuery, GetAccountUsersQueryVariables>;
export const GetOrganizationProfileDocument = gql`
    query getOrganizationProfile($input: GetAccountInput!) {
  getAccountRecord(input: $input) {
    account_id
    account_name
    phone_number
    email
    profile_picture
    billing_address
    billing_address2
    city
    region_id
    status_id
    country_id
    zip_postal
    account_address
    account_address2
    account_city
    account_country_id
    account_id
    account_name
    account_region_id
    account_zip_postal
  }
}
    `;
export function useGetOrganizationProfileQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables> & ({ variables: GetOrganizationProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>(GetOrganizationProfileDocument, options);
      }
export function useGetOrganizationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>(GetOrganizationProfileDocument, options);
        }
// @ts-ignore
export function useGetOrganizationProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>;
export function useGetOrganizationProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationProfileQuery | undefined, GetOrganizationProfileQueryVariables>;
export function useGetOrganizationProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>(GetOrganizationProfileDocument, options);
        }
export type GetOrganizationProfileQueryHookResult = ReturnType<typeof useGetOrganizationProfileQuery>;
export type GetOrganizationProfileLazyQueryHookResult = ReturnType<typeof useGetOrganizationProfileLazyQuery>;
export type GetOrganizationProfileSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationProfileSuspenseQuery>;
export type GetOrganizationProfileQueryResult = Apollo.QueryResult<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>;
export const GetAccountKpiDocument = gql`
    query getAccountKpi($input: GetAccountInput!) {
  getAccountRecord(input: $input) {
    account_id
    kpi {
      active_patients
      patients_with_alerts
      alerts_within_24_hours
      open_alerts
      patients_with_devices
    }
  }
}
    `;
export function useGetAccountKpiQuery(baseOptions: Apollo.QueryHookOptions<GetAccountKpiQuery, GetAccountKpiQueryVariables> & ({ variables: GetAccountKpiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountKpiQuery, GetAccountKpiQueryVariables>(GetAccountKpiDocument, options);
      }
export function useGetAccountKpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountKpiQuery, GetAccountKpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountKpiQuery, GetAccountKpiQueryVariables>(GetAccountKpiDocument, options);
        }
// @ts-ignore
export function useGetAccountKpiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountKpiQuery, GetAccountKpiQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountKpiQuery, GetAccountKpiQueryVariables>;
export function useGetAccountKpiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountKpiQuery, GetAccountKpiQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountKpiQuery | undefined, GetAccountKpiQueryVariables>;
export function useGetAccountKpiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountKpiQuery, GetAccountKpiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountKpiQuery, GetAccountKpiQueryVariables>(GetAccountKpiDocument, options);
        }
export type GetAccountKpiQueryHookResult = ReturnType<typeof useGetAccountKpiQuery>;
export type GetAccountKpiLazyQueryHookResult = ReturnType<typeof useGetAccountKpiLazyQuery>;
export type GetAccountKpiSuspenseQueryHookResult = ReturnType<typeof useGetAccountKpiSuspenseQuery>;
export type GetAccountKpiQueryResult = Apollo.QueryResult<GetAccountKpiQuery, GetAccountKpiQueryVariables>;
export const UpdateAccountBillingAddressDocument = gql`
    mutation updateAccountBillingAddress($input: UpdateAccountBillingAddressModelInput!) {
  updateAccountBillingAddress(input: $input) {
    success
    message
    data {
      account_id
      updated_at
      billing_address
      billing_address2
      city
      region_id
      country_id
      zip_postal
    }
  }
}
    `;
export type UpdateAccountBillingAddressMutationFn = Apollo.MutationFunction<UpdateAccountBillingAddressMutation, UpdateAccountBillingAddressMutationVariables>;
export function useUpdateAccountBillingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountBillingAddressMutation, UpdateAccountBillingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountBillingAddressMutation, UpdateAccountBillingAddressMutationVariables>(UpdateAccountBillingAddressDocument, options);
      }
export type UpdateAccountBillingAddressMutationHookResult = ReturnType<typeof useUpdateAccountBillingAddressMutation>;
export type UpdateAccountBillingAddressMutationResult = Apollo.MutationResult<UpdateAccountBillingAddressMutation>;
export type UpdateAccountBillingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAccountBillingAddressMutation, UpdateAccountBillingAddressMutationVariables>;
export const UpdateAccountRecordDocument = gql`
    mutation updateAccountRecord($input: UpdateAccountModelInput!) {
  updateAccountRecord(input: $input) {
    success
    message
    data {
      account_id
      account_name
      phone_number
      email
      profile_picture
      billing_address
      billing_address2
      city
      region_id
      status_id
      country_id
      zip_postal
      account_address
      account_address2
      account_city
      account_country_id
      account_id
      account_name
      account_region_id
      account_zip_postal
    }
  }
}
    `;
export type UpdateAccountRecordMutationFn = Apollo.MutationFunction<UpdateAccountRecordMutation, UpdateAccountRecordMutationVariables>;
export function useUpdateAccountRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountRecordMutation, UpdateAccountRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountRecordMutation, UpdateAccountRecordMutationVariables>(UpdateAccountRecordDocument, options);
      }
export type UpdateAccountRecordMutationHookResult = ReturnType<typeof useUpdateAccountRecordMutation>;
export type UpdateAccountRecordMutationResult = Apollo.MutationResult<UpdateAccountRecordMutation>;
export type UpdateAccountRecordMutationOptions = Apollo.BaseMutationOptions<UpdateAccountRecordMutation, UpdateAccountRecordMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($input: DeleteAccountInput!) {
  deleteAccount(input: $input) {
    success
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListAccounts = withQueryResponseHandler(useListAccountsQuery);
export const useListAccountChildren = withQueryResponseHandler(useListAccountChildrenQuery);
export const useGetAccountRecord = withQueryResponseHandler(useGetAccountRecordQuery);
export const useGetAccountUsers = withQueryResponseHandler(useGetAccountUsersQuery);
export const useGetOrganizationProfile = withQueryResponseHandler(useGetOrganizationProfileQuery);
export const useGetAccountKpi = withQueryResponseHandler(useGetAccountKpiQuery);
export const useUpdateAccountBillingAddress = withMutationResponseHandler(useUpdateAccountBillingAddressMutation, "updateAccountBillingAddress");
export const useUpdateAccountRecord = withMutationResponseHandler(useUpdateAccountRecordMutation, "updateAccountRecord");
export const useDeleteAccount = withMutationResponseHandler(useDeleteAccountMutation, "deleteAccount");